module.exports = __webpack_public_path__ + "static/media/8.93b4fcd1.jpeg";